import Vue from 'vue'
import Vuetify from 'vuetify/lib'

Vue.use(Vuetify)

export default new Vuetify({
})

// import Vue from 'vue'
// import Vuetify from 'vuetify/lib'

// Vue.use(Vuetify)

// export default new Vuetify({
//     icons: {
//         iconfont: 'mdiSvg',
//     },
// })

//import '@mdi/font/css/materialdesignicons.css' // Ensure you are using css-loader
